import { BaseService } from "./base-service";
import { API_BASE_URL } from "configuration/config";

/**
 * Service for calling the status-rules module endpoints.
 *
 * These endpoints handle status transitions with server-side validation and bubble-up logic.
 * The service can be used as:
 * - Fire-and-forget (shadow mode): caller invokes and ignores the promise
 * - Primary: caller awaits the response
 */
class StatusRulesService extends BaseService {
  constructor() {
    super(API_BASE_URL);
  }

  /**
   * PATCH /orders/{orderId}/items/{itemId}/sublines/{subLineId}
   */
  public async updateSubLine(
    orderId: string,
    itemId: string,
    subLineId: string,
    payload: Record<string, unknown>,
    csrfToken: string,
    consumer: string,
  ): Promise<Response> {
    return this.fetch(`/orders/${encodeURIComponent(orderId)}/items/${encodeURIComponent(itemId)}/sublines/${encodeURIComponent(subLineId)}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": csrfToken,
      },
      body: JSON.stringify({ consumer, ...payload }),
    });
  }

  /**
   * POST /orders/{orderId}/items/{itemId}/sublines
   */
  public async createSubLine(
    orderId: string,
    itemId: string,
    payload: Record<string, unknown>,
    csrfToken: string,
    consumer: string,
  ): Promise<Response> {
    return this.fetch(`/orders/${encodeURIComponent(orderId)}/items/${encodeURIComponent(itemId)}/sublines`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": csrfToken,
      },
      body: JSON.stringify({ consumer, ...payload }),
    });
  }

  /**
   * PATCH /orders/{orderId}/items/{itemId}
   */
  public async updateItem(
    orderId: string,
    itemId: string,
    payload: Record<string, unknown>,
    csrfToken: string,
    consumer: string,
  ): Promise<Response> {
    return this.fetch(`/orders/${encodeURIComponent(orderId)}/items/${encodeURIComponent(itemId)}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": csrfToken,
      },
      body: JSON.stringify({ consumer, ...payload }),
    });
  }

  /**
   * PATCH /orders/{orderId}/status
   */
  public async updateOrderStatus(
    orderId: string,
    payload: Record<string, unknown>,
    csrfToken: string,
    consumer: string,
  ): Promise<Response> {
    return this.fetch(`/orders/${encodeURIComponent(orderId)}/status`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-csrf-token": csrfToken,
      },
      body: JSON.stringify({ consumer, ...payload }),
    });
  }
}

export const statusRulesService = new StatusRulesService();
